import { render, staticRenderFns } from "./QuestionnaireCancellation.vue?vue&type=template&id=5bf3051e&scoped=true"
import script from "./QuestionnaireCancellation.vue?vue&type=script&lang=js"
export * from "./QuestionnaireCancellation.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireCancellation.vue?vue&type=style&index=0&id=5bf3051e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf3051e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bf3051e')) {
      api.createRecord('5bf3051e', component.options)
    } else {
      api.reload('5bf3051e', component.options)
    }
    module.hot.accept("./QuestionnaireCancellation.vue?vue&type=template&id=5bf3051e&scoped=true", function () {
      api.rerender('5bf3051e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/service-satisfaction-questionnaire/components/QuestionnaireCancellation.vue"
export default component.exports